module.exports = __webpack_public_path__ + "static/media/encryption.98d1679e.svg";